import { useEffect, useState } from 'react';

import { CheckMark } from 'components/CheckMark';

import * as S from './Checkbox.styles';

type CheckboxProps = {
  name: string;
  label: string;
  defaultChecked?: boolean;
  hasBorderContainer?: boolean;
  margin?: string;
  disabled?: boolean;
  onChange: (e: boolean) => void;
};

const defaultProps: Partial<CheckboxProps> = {
  name: undefined,
  defaultChecked: false,
  hasBorderContainer: false,
  margin: undefined,
  disabled: false,
};

export function Checkbox(props: CheckboxProps): React.ReactElement {
  const { label, disabled, onChange, defaultChecked } = {
    ...defaultProps,
    ...props,
  };

  const [isChecked, isCheckedSet] = useState(false);

  useEffect(() => {
    if (defaultChecked) {
      isCheckedSet(defaultChecked);
    }
  }, [defaultChecked]);

  return (
    <S.Wrapper>
      <CheckMark
        disabled={disabled}
        isChecked={isChecked}
        onClick={() => {
          onChange(!isChecked);
          isCheckedSet(!isChecked);
        }}
      />

      <S.Label>{label}</S.Label>
    </S.Wrapper>
  );
}
